import React from 'react';
import PowerplantRowAbstract from './PowerplantRowAbstract';
import { Label } from 'react-bootstrap';
import { FaLink, FaUnlink } from "react-icons/fa";
import Power from './Power';
import Trackers from './Trackers';
import services from '../../lib/Services';
import './powerplants.css';

/**
 * Powerplants' Table for mobile screen.
 * @copyright Optimum Tracker
 * @author wkoffi
 */
class PowerplantRowMini extends PowerplantRowAbstract
{
	getLength = (number) => {
		let nb = Math.ceil(number)
		return nb.toString().length;
	};
	
	render()
	{
        if(this.props.powerplant.isDisplayed() === false) return (null);
        const status = this.props.powerplant.getStatus();
        const status_icon = (status === 0) ? <FaLink size={20} color="green" title="Connected" /> : ((status === 2) ? <FaLink size={20} color="orange" title="Connected with warnings" /> : <FaUnlink size={20} color="#d9534f" title="Disconnected" />)
        return (
				<tr><td><div className={(status === 1) ? "lost-remote-connection-true powerplant-style-screen-mode" : "central-items lost-remote-connection-false row powerplant-style-screen-mode"}>
					<div className="row-mini-header">
                        <div>
                            {status_icon}
                        </div>
                        <div className="name-padding">
							<a className="name" href={ services.getMonitoringUrl(this.props.powerplant.getAppId()) } target="_blank" rel="noopener noreferrer"><strong>{this.props.powerplant.getName()}</strong></a>
						</div>
                        <div className="power-position">
                            <Power powerplant={this.props.powerplant} />
                        </div>
					</div>
					<Trackers powerplant={this.props.powerplant} />
					<div className="wind wind-location" style={{paddingBottom: '10px', paddingTop: '7px'}}>
						<span className="powerplant-wind"> { this.props.powerplant.getWindSpeed() } km/h { this.state.WindDirectionDisplay && this.getDirectionAsString(this.state.WindDirection) }</span>
						<img
							src={this.state.OneWindSafety ? "/images/logo/shields3.png" : "/images/logo/shield1.png"}
							width="15"
							height="15"
							className={"location-image-wind-speed windsafety-logo-responsive wind-safety-margin"}
							alt="Wind safety"
                            title={this.state.OneWindSafety ? "Wind safety ON" : "Wind safety OFF"} />
					</div>
                    { services.getUser().isSuperAdmin() && (<div>
                        { this.props.powerplant.getWarnings().map(line => <Label key={line[1]} bsStyle={line[0] === 2 ? "warning" : "danger"}>{line[1]}</Label>) }
                    </div> )}
				</div></td></tr>
		);
	}
}

PowerplantRowMini.defaultProps = {
	powerplant: {},
    refreshOnLoad: function(){}
};

export default PowerplantRowMini;